import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { EventsService } from 'src/app/services/events-service/events.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { EMPTY, Subscription } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-events-event-occupancy-card',
  templateUrl: './events-event-occupancy-card.component.html',
  styleUrls: ['./events-event-occupancy-card.component.scss']
})
export class EventsEventOccupancyCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() alert;
  @Input() availableDesks;
  occupancyAlerts;
  updateAlertCapacityListSubscription: Subscription;
  basicDataForm = new FormGroup({
    selectedDesk: new FormControl(null, Validators.required),
    occupancyValue: new FormControl(null, Validators.required)
  });

  constructor(private eventsService: EventsService,
              private snackbarService: SnackBarService) { }

  ngOnInit() { }

  ngOnChanges() {
    if (this.alert && this.availableDesks) {
      this.resetForm();
    }
  }

  public addOccupancy() {
    const validation = this.validateForm();
    if (validation === true) {
      this.alert.CenterAlertCapacityList.push({deskName: this.getSelectedDesk().DeskName, deskInternalId: this.getSelectedDesk().InternalId, deskCapacityLimit: this.basicDataForm.get('occupancyValue').value });
      this.updateAlertOccupancy(this.alert.CenterAlertCapacityList);
    } else {
      this.snackbarService.open(validation, 'error');
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('selectedDesk').valid) {
      return 'events-page.snackbar messages.event occupation selected desk required error';
    } else if (!this.basicDataForm.get('occupancyValue').valid) {
      return 'events-page.snackbar messages.event occupation value limit required error';
    } else {
      return true;
    }
  }

  public deleteOccupancy(occupancy) {
    const occupancies = this.alert.centerAlertCapacityList.filter(o => {
      return o.deskInternalId !== occupancy.deskInternalId;
    });
    this.updateAlertOccupancy(occupancies);
  }

  private updateAlertOccupancy(occupancies) {
    this.updateAlertCapacityListSubscription = this.eventsService.updateAlertCapacityList(this.alert.InternalId, occupancies).pipe(
      tap(o => this.eventsService.refreshAlert()),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      selectedDesk: this.setSelectedDesk()
    });
  }

  public setSelectedDesk() {
    if (this.alert && this.availableDesks && this.availableDesks.length > 0) {
      for (const desk of this.availableDesks) {
        if (desk.CenterInternalId === this.alert.CenterInternalId) {
          return desk;
        }
      }
    } else {
      return null;
    }
  }

  public getSelectedDesk() {
    if (this.availableDesks.length === 1) {
      return this.availableDesks[0];
    } else {
      if (this.basicDataForm.get('selectedDesk').value) {
        return this.basicDataForm.get('selectedDesk').value;
      } else {
        return null;
      }
    }
  }

  public filterOnlyPositiveIntegers(e) {
    return e.charCode > 48;
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  ngOnDestroy() {
    if (this.updateAlertCapacityListSubscription) { this.updateAlertCapacityListSubscription.unsubscribe(); }
  }
}
